/** Thin fetch wrapper for /api/v1. Returns null when the server can't be reached, so the game keeps working offline. */
const BASE = '/api/v1';
const TIMEOUT_MS = 8000;

export interface ApiFailure {
  ok: false;
  status: number;
  code: string;
  message: string;
}

export type ApiResult<T> = ({ ok: true } & T) | ApiFailure;

export async function api<T>(method: string, path: string, key: string | null, body?: unknown): Promise<ApiResult<T> | null> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (key) headers.Authorization = `Bearer ${key}`;
    const response = await fetch(BASE + path, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), signal: controller.signal });
    const type = response.headers.get('content-type') ?? '';
    if (!type.includes('application/json')) return null;
    const json = (await response.json()) as { ok: boolean; error?: { code: string; message: string } } & T;
    if (json.ok) return json as { ok: true } & T;
    return { ok: false, status: response.status, code: json.error?.code ?? 'UNKNOWN', message: json.error?.message ?? '' };
  } catch {
    return null;
  } finally {
    clearTimeout(timer);
  }
}
